const asRich = (text) => [{ text }]
const asTitle = (text) => [{ text }]

export const barPageByLocale = {
  'en-us': {
    hero: {
      content: asRich(
        'Come and try our new bar, OBAR, harmonizing with the lobby of our hotel where champagne cocktails and local products are part of our specialties.'
      ),
    },
    location: {
      heading: asTitle('Located in the lobby of the Griffintown Hotel'),
      content: asRich(
        'The industrial birthplace of Canada and just steps from downtown Montreal, Griffintown is reborn as an artistic composite of 200-year-old factories converted into galleries, restaurants, boutiques and residences. Innovators put their money and imagination into it, and the profits made headlines around the world.'
      ),
    },
  },
  'fr-ca': {
    hero: {
      content: asRich(
        "Venez essayer notre nouveau bar, OBAR, s'harmonisant avec le lobby de notre hôtel où cocktails au champagne et produits locaux font parties de nos spécialités."
      ),
    },
    location: {
      heading: asTitle('Situé dans le lobby du Griffintown Hôtel'),
      content: asRich(
        "Lieu de naissance industriel du Canada et à quelques pas du centre-ville de Montréal, Griffintown renaît en tant que composite artistique dirigé d'usines vieilles de 200 ans reconverties en galeries, en restaurants, en boutiques et en résidences. Les innovateurs y ont investi fonds et imagination et les bénéfices ont fait la une des journaux du monde entier."
      ),
    },
  },
}

const L = (...strings) => strings.map((text) => ({ text }))

const conceptAmenityGroups = {
  'en-us': [
    {
      title: asTitle('Kitchen'),
      list: L(
        'Dishes & Utensils',
        'Wine glasses',
        'Microwave',
        'Blomberg cooking top',
        'Blomberg oven',
        'Blomberg fridge',
        'Nespresso Coffee Maker',
        'Toaster'
      ),
    },
    {
      title: asTitle('Bedroom'),
      list: L(
        'Queen or King Size bed',
        'High Quality Bedding Set',
        'USB Charging Ports & Power Sockets By The Bed'
      ),
    },
    {
      title: asTitle('Living'),
      list: L(
        '43" Smart Flat Screen HD TV',
        'Over 50 TV channels & Netflix',
        'Free High-Speed Internet',
        'Sofa-bed (upon request)',
        'Private balcony'
      ),
    },
    {
      title: asTitle('Bath'),
      list: L(
        'Blomberg - Washer & Dryer',
        'Quartz Finished',
        'Waterfall shower heads',
        'Hair dryer',
        'Pure Bath Products',
        'Private Bathrooms'
      ),
    },
  ],
  'fr-ca': [
    {
      title: asTitle('Cuisine'),
      list: L(
        'Vaisselle',
        'Verres à vin',
        'Ustensiles',
        'Four à micro-ondes',
        'Table de cuisson Blomberg',
        'Cuisinière Blomberg',
        'Réfrigérateur Blomberg',
        'Machine à café Nespresso',
        'Grille-pain'
      ),
    },
    {
      title: asTitle('Chambre à coucher'),
      list: L(
        'Grand lit ou Très Grand lit',
        'Literie de haute qualité',
        'Ports de charge USB et prises de courant près du lit'
      ),
    },
    {
      title: asTitle('Salon'),
      list: L(
        'Téléviseur intelligent HD 43 po à écran plat',
        'Plus de 50 chaînes de télévision et accès à Netflix',
        'Internet à haute vitesse gratuit',
        'Grand canapé-lit (sur demande)',
        'Balcon privé avec accès direct'
      ),
    },
    {
      title: asTitle('Salle de bain'),
      list: L(
        'Machine à laver et sécheuse Blomberg',
        'Finition en quartz',
        'Salle de bain entièrement privée',
        'Douche cascade',
        'Sèche-cheveux',
        'Produits de bain Pure'
      ),
    },
  ],
}

export const conceptPageByLocale = {
  'en-us': {
    heading: asTitle('Home Away from Home'),
    subheading: asTitle('Welcome home'),
    content: [
      {
        text:
          'Welcome in one of our uniquely designed condo-like apartment. Every apartment wraps you in soothing soft, neutral colour in a unique architectural design. Feel like cooking for friends? Spending a quiet night catching up with laundry? Enjoying your favourite movie after a long day? Our goal is to make you feel at home every single day even a thousand kilometers away.',
      },
      { text: 'Each apartment includes the following:' },
    ],
    amenity_group: conceptAmenityGroups['en-us'],
  },
  'fr-ca': {
    heading: asTitle('Un confort comme chez soi'),
    subheading: asTitle('Bienvenue chez vous'),
    content: [
      {
        text:
          'Au Griffintown Hotel, chaque appartement vous enveloppe d’une couleur douce et apaisante dans un design architectural unique. Envie de cuisiner pour des amis? Vous passez une journée tranquille à rattraper votre lessive? Vous voulez simplement écouter votre série préférée en rafale après une longue journée? Notre objectif est de vous faire sentir chez vous, même à des milliers de kilomètres.',
      },
      { text: 'Chaque suite comprend les éléments suivants:' },
    ],
    amenity_group: conceptAmenityGroups['fr-ca'],
  },
}

export const exploreMontrealByLocale = {
  'en-us': {
    title: asTitle('One of Montreal’s most coveted locations'),
    subheading: asTitle(
      'Located on rue des Bassins, the hotel is located in the neighbourhood of Griffintown, where new restaurants, proximity services and parks have transformed the neighbourhood into one of the most coveted in Montreal.'
    ),
    content: [
      {
        text:
          'Canada’s industrial birthplace and an easy walk from the downtown Montreal core, Griffintown has been reborn as an art-directed mashup of 200-year-old factories reclaimed as galleries, restaurants, shops and residences. Innovators have invested money and imagination and the gains have made headlines worldwide.',
      },
    ],
    attractions: [
      'Mount-Royal',
      'Canal Lachine',
      'Old Montreal',
      'Botanical Garden',
      'Notre-Dame Basilica',
      "St. Joseph's Oratory",
      'Parc Jean Drapeau',
      'Fine Arts Museum',
      'Pointe-à-Callière',
      'Place des Arts',
      'Atwater Market',
      'McCord Museum',
      'Olympic Park',
      'Arsenal Contemporary Art Museum',
      'Clock Tower Beach',
      'La Grande Roue',
    ].map((t) => ({ text: [{ text: t }] })),
    restaurants_and_bars: [
      'Bird Bar / Henden',
      'Gh Espace Cafe',
      'Industria Pizzeria+Bar',
      'Pizzeria Moretti',
      'Le Richmond',
      'Maman',
      'Grinder',
      'Chez Sophie',
      'ZIBO!',
      'Foxy',
      'Makro',
      'Monopole',
      'Manu Cornuto',
      'La bête à pain',
      'New City Gas',
      'Perles et Paddock',
      'Le Boucan Smokehouse',
      'Rockaberry',
      'Brasseur Montreal',
      'Le Trou',
    ].map((t) => ({ text: [{ text: t }] })),
  },
  'fr-ca': {
    title: asTitle('L’un des endroits les plus convoités de Montréal'),
    subheading: asTitle(
      'Situé sur la rue des Bassins, notre hôtel se trouve dans le quartier Griffintown où de nouveaux restaurants, services de proximité et parcs ont transformé le quartier en l’un des plus convoités de Montréal.'
    ),
    content: [
      {
        text:
          'Lieu de naissance industriel du Canada et à quelques pas du centre-ville de Montréal, Griffintown renaît en tant que composite artistique dirigé d’usines vieilles de 200 ans reconverties en galeries, en restaurants, en boutiques et en résidences. Les innovateurs y ont investi fonds et imagination et les bénéfices ont fait la une des journaux du monde entier.',
      },
    ],
    attractions: [
      'Mont-Royal',
      'Canal Lachine',
      'Vieux-Montréal',
      'Jardin Botanique',
      'Basilique Notre-Dame',
      'Oratoire Saint-Joseph',
      'Parc Jean Drapeau',
      'Musée des Beaux-Arts',
      'Musée Pointe-à-Callière',
      'Place des Arts',
      'Marché Atwater',
      'Musée McCord',
      'Parc Olympique',
      'Arsenal Musée d’Art Contemporain',
      'Plage de l’horloge',
      'La Grande roue',
    ].map((t) => ({ text: [{ text: t }] })),
    restaurants_and_bars: [
      'Gh Espace Cafe',
      'Bird Bar / Henden',
      'Industria Pizzeria+Bar',
      'Pizzeria Moretti',
      'Le Richmond',
      'Maman',
      'Grinder',
      'Chez Sophie',
      'ZIBO!',
      'Foxy',
      'Makro',
      'Monopole',
      'Manu Cornuto',
      'La bête à pain',
      'Le trou bagels',
      'New City Gas',
      'Perles et Paddock',
      'Le Boucan Smokehouse',
      'Rockaberry',
      'Brasseur Montreal',
    ].map((t) => ({ text: [{ text: t }] })),
  },
}

export const covidHeadingByLocale = {
  'en-us': 'COVID information',
  'fr-ca': 'Information relative au COVID',
}

export const policiesHeaderByLocale = {
  'en-us': {
    eyebrow: [{ text: 'Policies' }],
    heading: [{ text: 'Our Policies' }],
  },
  'fr-ca': {
    eyebrow: [{ text: 'Politiques' }],
    heading: [{ text: "Règlements et Politiques de l'hôtel" }],
  },
}
